export interface BlogPost {
  id: number;
  title: string;
  desc: string;
  date: string;
  time: string;
  topic: string;
  image: string;
  featured: boolean;
  keyword: string;
  content: string;
  slug?: string;
}

export const topics = [
  'All Topics',
  'E-commerce',
  'Digital Marketing',
  'Web Development',
  'Business Strategy',
  'Technology',
  'Design',
  'Development',
  'Updates',
  'Email Marketing',
  'Rate Optimization',
];

export const allPosts: BlogPost[] = [
  {
    id: 1,
    title: 'The Future of E-commerce: Trends to Watch in 2024',
    desc: 'Explore the latest trends shaping the e-commerce landscape in 2024 and beyond.',
    date: '20/3/2024',
    time: '5 min read',
    topic: 'E-commerce',
    image: '/images/posts/blog1/blog1.jpg',
    featured: true,
    keyword: 'e-commerce, trends, 2024, future',
    content: `
      <h2>Introduction</h2>
      <p>The e-commerce landscape is constantly evolving, with new technologies and consumer behaviors shaping the future of online shopping. In this comprehensive guide, we'll explore the key trends that are set to transform the industry in 2024.</p>

      <h2>1. AI-Powered Shopping Experiences</h2>
      <p>Artificial Intelligence is revolutionizing how customers interact with online stores. From personalized recommendations to virtual shopping assistants, AI is making shopping more intuitive and efficient.</p>
      
      <blockquote>
        "AI is not just a trend; it's becoming the backbone of modern e-commerce platforms."
      </blockquote>

      <h3>Key AI Applications in E-commerce</h3>
      <ul>
        <li>Personalized product recommendations</li>
        <li>Chatbots for customer service</li>
        <li>Visual search capabilities</li>
        <li>Predictive inventory management</li>
      </ul>

      <img src="/images/blog/ai-shopping.jpg" alt="AI-powered shopping interface">

      <h2>2. Mobile Commerce Evolution</h2>
      <p>Mobile commerce continues to grow, with new features and capabilities being added regularly. Here's what to expect:</p>

      <table>
        <tr>
          <th>Feature</th>
          <th>Impact</th>
        </tr>
        <tr>
          <td>Progressive Web Apps</td>
          <td>Faster loading times and offline capabilities</td>
        </tr>
        <tr>
          <td>Mobile Wallets</td>
          <td>Streamlined checkout process</td>
        </tr>
        <tr>
          <td>AR Shopping</td>
          <td>Enhanced product visualization</td>
        </tr>
      </table>

      <h2>3. Sustainable E-commerce</h2>
      <p>Sustainability is becoming a crucial factor in consumer decision-making. E-commerce businesses are adapting by:</p>

      <ol>
        <li>Implementing eco-friendly packaging</li>
        <li>Offering carbon-neutral shipping</li>
        <li>Supporting sustainable brands</li>
        <li>Providing transparency in supply chains</li>
      </ol>

      <h3>Code Example: Implementing Green Shipping</h3>
      <pre><code>
      const calculateGreenShipping = (order) => {
        const distance = calculateDistance(order);
        const carbonFootprint = distance * CARBON_FACTOR;
        return {
          carbonOffset: carbonFootprint * OFFSET_RATE,
          shippingMethod: 'eco-friendly'
        };
      };
      </code></pre>

      <h2>Conclusion</h2>
      <p>As we move through 2024, these trends will continue to shape the e-commerce landscape. Businesses that adapt and implement these changes will be well-positioned for success in the evolving digital marketplace.</p>

      <p>For more information about implementing these trends in your business, <a href="/contact">contact our team</a> for a consultation.</p>
    `
  },
  {
    id: 2,
    title: 'Digital Marketing Strategies for 2024',
    desc: 'Discover effective digital marketing strategies to boost your online presence.',
    date: '20/1/2024',
    time: '4 min read',
    topic: 'Digital Marketing',
    image: '/images/blog/blog_02.jpg',
    featured: true,
    keyword: 'digital marketing, strategy, 2024',
    content: `
      <h2>Introduction to Modern Digital Marketing</h2>
      <p>Digital marketing continues to evolve at a rapid pace. Let's explore the most effective strategies for 2024.</p>

      <h2>1. Content Marketing Excellence</h2>
      <p>Content remains king in digital marketing, but the approach has evolved significantly.</p>

      <blockquote>
        "Quality content that provides value to your audience is more important than ever."
      </blockquote>

      <h3>Content Types That Drive Engagement</h3>
      <ul>
        <li>Video content and live streaming</li>
        <li>Interactive infographics</li>
        <li>Long-form articles</li>
        <li>Podcasts and audio content</li>
      </ul>

      <img src="/images/blog/content-marketing.jpg" alt="Content marketing strategy">

      <h2>2. Social Media Strategy</h2>
      <p>Social media platforms continue to be crucial for brand visibility and engagement.</p>

      <table>
        <tr>
          <th>Platform</th>
          <th>Best Use Case</th>
        </tr>
        <tr>
          <td>Instagram</td>
          <td>Visual content and stories</td>
        </tr>
        <tr>
          <td>LinkedIn</td>
          <td>Professional networking</td>
        </tr>
        <tr>
          <td>TikTok</td>
          <td>Short-form video content</td>
        </tr>
      </table>

      <h2>3. SEO Best Practices</h2>
      <p>Search engine optimization remains a cornerstone of digital marketing success.</p>

      <h3>Key SEO Elements</h3>
      <ol>
        <li>Technical SEO optimization</li>
        <li>Quality backlink building</li>
        <li>Local SEO strategies</li>
        <li>Mobile-first indexing</li>
      </ol>

      <pre><code>
      // Example of structured data implementation
      const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Digital Marketing Course",
        "description": "Comprehensive digital marketing training"
      };
      </code></pre>

      <h2>Conclusion</h2>
      <p>Success in digital marketing requires a balanced approach that combines various strategies. Stay updated with the latest trends and continuously optimize your approach.</p>

      <p>Ready to enhance your digital marketing strategy? <a href="/contact">Get in touch</a> with our experts.</p>
    `
  },
  {
    id: 3,
    title: "6 Product Launch theif Email Example",
    desc: "Mauris blandit aliquet elit, eget tincidunt nibh dolor sit amet,",
    date: "20/3/2022",
    time: "10 Min To Read",
    topic: "Development",
    image: "/images/posts/blog3.jpg",
    featured: true,
    keyword: "product launch, email marketing, examples",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
  },
  {
    id: 4,
    title: "Keep on Top of your With Felix's Slick New",
    desc: "Mauris blandit aliquet elit, eget tincidunt nibh dolor sit amet,",
    date: "20/3/2024",
    time: "10 Min To Read",
    topic: "Development",
    image: "/images/posts/blog4.jpg",
    featured: true,
    keyword: "productivity, task management, tools",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
  },
  {
    id: 5,
    title: "How Video Analytics Can Help Understand and Increase",
    desc: "Mauris blandit aliquet elit, eget tincidunt nibh dolor sit amet,",
    date: "20/3/2024",
    time: "10 Min To Read",
    topic: "Updates",
    image: "/images/posts/blog5/blog5.jpg",
    featured: true,
    keyword: "video analytics, data analysis, performance",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
  },
  {
    id: 6,
    title: "Keep on Top of your To-Do List With Slick New Comment",
    desc: "Mauris blandit aliquet elit, eget tincidunt nibh dolor sit amet,",
    date: "20/3/2024",
    time: "10 Min To Read",
    topic: "Email Marketing",
    image: "/images/posts/blog6.jpg",
    featured: true,
    keyword: "task management, productivity, comments",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
  },
  {
    id: 7,
    title: "6 Product Launch Email Examples You'll Want to Steal",
    desc: "Mauris blandit aliquet elit, eget tincidunt nibh dolor sit amet,",
    date: "20/3/2024",
    time: "10 Min To Read",
    topic: "Rate Optimization",
    image: "/images/posts/blog7.jpg",
    featured: true,
    keyword: "email marketing, product launch, examples",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
  },
  {
    id: 8,
    title: "Learn from the Best: 6 of the Top Automotive Email",
    desc: "Mauris blandit aliquet elit, eget tincidunt nibh dolor sit amet,",
    date: "20/3/2024",
    time: "10 Min To Read",
    topic: "Email Marketing",
    image: "/images/posts/blog8.jpg",
    featured: false,
    keyword: "automotive, email marketing, best practices",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
  },
  {
    id: 9,
    title: "8 E-Commerce Email Marketing Best Practices To",
    desc: "Mauris blandit aliquet elit, eget tincidunt nibh dolor sit amet,",
    date: "20/3/2024",
    time: "10 Min To Read",
    topic: "Email Marketing",
    image: "/images/posts/blog9.jpg",
    featured: false,
    keyword: "e-commerce, email marketing, best practices",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
  },
  {
    id: 10,
    title: "Learn from These 6 Travel Boost Leads by 162 Percent",
    desc: "Mauris blandit aliquet elit, eget tincidunt nibh dolor sit amet,",
    date: "20/3/2024",
    time: "10 Min To Read",
    topic: "Updates",
    image: "/images/posts/blog10.jpg",
    featured: false,
    keyword: "travel, lead generation, marketing",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
  },
  {
    id: 11,
    title: "How Video Analytics Can Help Understand and Increase",
    desc: "Mauris blandit aliquet elit, eget tincidunt nibh dolor sit amet,",
    date: "20/3/2024",
    time: "10 Min To Read",
    topic: "Development",
    image: "/images/posts/blog11.jpg",
    featured: false,
    keyword: "video analytics, performance, development",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
  },
  {
    id: 12,
    title: "Keep on Top of your To-Do List With Slick New Comment",
    desc: "Mauris blandit aliquet elit, eget tincidunt nibh dolor sit amet,",
    date: "20/3/2024",
    time: "10 Min To Read",
    topic: "Email Marketing",
    image: "/images/posts/blog12.jpg",
    featured: false,
    keyword: "task management, productivity, comments",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
  },
  {
    id: 13,
    title: "6 Product",
    desc: "Mauris blandit aliquet elit, eget tincidunt nibh dolor sit amet,",
    date: "23/3/2025",
    time: "10 Min To Read",
    topic: "Rate Optimization",
    image: "/images/posts/blog13.jpg",
    featured: false,
    keyword: "product launch, email marketing, examples",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
  },
  {
    id: 14,
    title: "6 Product Launch",
    desc: "Mauris blandit aliquet elit, eget tincidunt nibh dolor sit amet,",
    date: "21/3/2025",
    time: "10 Min To Read",
    topic: "Rate Optimization",
    image: "/images/posts/blog13.jpg",
    featured: false,
    keyword: "product launch, email marketing, examples",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
  },
  {
    id: 15,
    title: "6 Product Launch E",
    desc: "Mauris blandit aliquet elit, eget tincidunt nibh dolor sit amet,",
    date: "20/3/2025",
    time: "10 Min To Read",
    topic: "Rate Optimization",
    image: "/images/posts/blog13.jpg",
    featured: false,
    keyword: "product launch, email marketing, examples",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
  },
]; 